module.exports = {
  s3: {
    fileLink: 'https://erp-modules-zolo-production.s3.amazonaws.com/',
  },
  urlRegxp : /^(http[s]?:\/\/)(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/,
  emptyRegxp : /^\s*$/,
  toolTipText: {
    "Pending Payments": {
      "City Finance": 'You will see the PRs which are in the following state: 1.Blocked  2.Pending at City Head  3.Pending at Central Finance  4.Rejected By City Head  5.Rejected by Central Finance',
      "City Head": 'You will see the PRs which are in the following state: 1.Pending at Central Finance',
      "Central Finance": 'You will see the PRs which are in the following state: 1.Blocked  2.Pending at City Head  3.Rejected By City Head  4.Rejected by Central Finance',
      "Super Central Finance": 'You will see the PRs which are in the following state: 1.Blocked  2.Pending at City Head  3.Rejected By City Head  4.Rejected by Central Finance',
      "root": 'You will see the PRs which are in the following state: 1.Blocked  2.Pending at City Head  3.Rejected By City Head  4.Rejected by Central Finance',
    },
    "Approve Payments": {
      "City Finance": '',
      "City Head": 'You will see the PRs which are in the following state: 1.Pending at City Head',
      "Central Finance": 'You will see the PRs which are in the following state: 1.Pending at Central Finance',
      "Super Central Finance": 'You will see the PRs which are in the following state: 1.Pending at Central Finance',
      "root": 'You will see the PRs which are in the following state: 1.Pending at Central Finance',
    },
    "Processed Payments": {
      "City Finance": 'You will see the PRs which are in the following state: 1.BUF Ready',
      "City Head": 'You will see the PRs which are in the following state: 1.BUF Ready',
      "Central Finance": 'You will see the PRs which are in the following state: 1.BUF Ready',
      "Super Central Finance": 'You will see the PRs which are in the following state: 1.BUF Ready',
      "root": 'You will see the PRs which are in the following state: 1.BUF Ready',
    },
    "Generated BUF": {
      "City Finance": 'You will see the PRs which are in the following state: 1.BUF Generated',
      "City Head": 'You will see the PRs which are in the following state: 1.BUF Generated',
      "Central Finance": 'You will see the PRs which are in the following state: 1.BUF Generated',
      "Super Central Finance": 'You will see the PRs which are in the following state: 1.BUF Generated',
      "root": 'You will see the PRs which are in the following state: 1.BUF Generated',
    },
    "Payment Status": {
      "City Finance": 'You will see the PRs whose Payment is done from the Bank',
      "City Head": 'You will see the PRs whose Payment is done from the Bank',
      "Central Finance": 'You will see the PRs whose Payment is done from the Bank',
      "Super Central Finance": 'You will see the PRs whose Payment is done from the Bank',
      "root": 'You will see the PRs whose Payment is done from the Bank',
    },
    "BUF Rejected PRS": {
      "City Finance": 'You will see the PRs whose Payment failed from the Bank',
      "City Head": 'You will see the PRs whose Payment failed from the Bank',
      "Central Finance": 'You will see the PRs whose Payment failed from the Bank',
      "Super Central Finance": 'You will see the PRs whose Payment failed from the Bank',
      "root": 'You will see the PRs whose Payment failed from the Bank',
    },
  },
  configurableTDS: {
    "standard": [0, 0.25, 0.5, 0.75, 0.1, 1, 1.5, 2, 3, 3.75, 4, 5, 7.5, 10],
    "Contracts": {
      "194C-contract": [0, 0.25, 0.5, 0.75, 0.1, 1, 1.5, 2],
      "194J -Any Professional Service": [0, 0.1, 0.25, 0.5, 1.5, 4, 7.5, 10],
      "194H -Commision": [0, 0.1, 0.25, 0.5, 3.75, 5],
      "194A- Interest on Loan": [0, 0.1, 0.25, 0.5, 1, 2, 3, 5, 7.5, 10],
      "194I-Rent": [0, 0.1, 0.25, 0.5, 0.75, 1.5, 2, 3.75, 7.5, 10],
      "194J-Any professional services": [0, 0.1, 0.25, 0.5, 1.5, 4, 7.5, 10],
      "194H-Commision": [0, 0.1, 0.25, 0.5, 3.75, 5],
      "194A-Interest on Loan": [0, 0.1, 0.25, 0.5, 1, 2, 3, 5, 7.5, 10],
    }
  }
}


// WEBPACK FOOTER //
// ./src/config/constants.js